module.exports = __webpack_public_path__ + "media/images/logo-shape-ca093267a6b94d759d17b3cf45b5e762.svg";